import { useMutation } from 'react-query'

import request from '../../config/axios'
import { Sponsor } from './useProviders'

interface ImpactTokenValidationResponse {
  sponsor: Sponsor
}

interface TokenParams {
  token?: string
}

const useImpactTokenValidation = () => {
  return useMutation((vars: TokenParams) => {
    const url = `/impacts/verify_sponsor_token/${vars.token}`
    return request.get<ImpactTokenValidationResponse>(url).then((response) => {
      return response.data
    })
  })
}

export default useImpactTokenValidation
